import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ShieldAlert, Cookie } from "lucide-react";
import { initAnalytics } from "@/lib/analytics";

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Check if consent has already been given or declined
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) {
      // Small timeout for nice visual entry
      const timer = setTimeout(() => setVisible(true), 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookie_consent", "accepted");
    setVisible(false);
    // Initialize Google Analytics immediately since they consented
    initAnalytics();
  };

  const handleDecline = () => {
    localStorage.setItem("cookie_consent", "declined");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-6 left-6 right-6 md:left-auto md:right-6 md:max-w-md z-40 animate-in fade-in slide-in-from-bottom-6 duration-300">
      <div className="border-4 border-foreground bg-background p-5 shadow-brutal flex flex-col gap-4 text-foreground">
        <div className="flex gap-3">
          <div className="h-8 w-8 bg-primary/20 border-2 border-foreground flex items-center justify-center shrink-0">
            <Cookie className="h-4.5 w-4.5 text-primary" />
          </div>
          <div className="space-y-1">
            <h4 className="text-[10px] font-black uppercase tracking-wider flex items-center gap-1">
              Cookie Consent Sentinel
            </h4>
            <p className="text-[10px] font-bold uppercase tracking-tight text-muted-foreground leading-relaxed">
              We use strictly necessary cookies to keep you logged in and optional analytics cookies to optimize performance. Read our{" "}
              <Link to="/privacy" className="underline hover:text-foreground">
                Privacy Policy
              </Link>{" "}
              and{" "}
              <Link to="/terms" className="underline hover:text-foreground">
                Terms
              </Link>
              .
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <Button
            onClick={handleAccept}
            className="flex-1 h-9 rounded-none border-2 border-foreground bg-foreground text-background font-black uppercase text-[9px] tracking-wider shadow-brutal-xs hover:bg-primary hover:text-primary-foreground transition-all"
          >
            Accept All
          </Button>
          <Button
            onClick={handleDecline}
            variant="outline"
            className="flex-1 h-9 rounded-none border-2 border-foreground bg-background text-foreground font-black uppercase text-[9px] tracking-wider shadow-brutal-xs hover:translate-x-[1px] hover:translate-y-[1px] hover:shadow-none transition-all"
          >
            Decline
          </Button>
        </div>
      </div>
    </div>
  );
}
